export const trackingParams = {
  UTM_SOURCE: 'utm_source',
  UTM_MEDIUM: 'utm_medium',
  UTM_CAMPAIGN: 'utm_campaign',
  REDIRECTION_FROM: 'rf',
  PAGE_SOURCE: 'source',
};

export const OFFER_ROOT = 'offer_root';
export const HIDDEN_UNDERSCORE = 'hidden_';
export const IS_FILTERED_URL = 'is_filtered_url';
export const PLP_WIDGETS = 'plpwidgets';
export const PINNED_PRODUCT_ID = 'pinned_product_id';
export const SEGMENTED_RANKINGS = 'segmented_ranking';
export const ENABLE_INLINE_PRICE_REVEAL = 'enable_pr';
export const ALGO_PARAM = 'algo';
export const UNDERSCORE_ALGO = '_algo';

export const INLINE_PRICE_REVEAL_VALUE = '1';
export const RELATED_SEARCHES_VALUE = 'related_search';

export const CUSTOMER_STATUS = 'customer_status';
export const CUSTOMER_NEW_VAL = '1';
export const CUSTOMER_REPEAT_VAL = '0';
